// extracted by mini-css-extract-plugin
export default {"l_DetailPageBtnTotalContainer_BtnContainer":"DetailPageBtnTotalContainer_l_DetailPageBtnTotalContainer_BtnContainer__ls2Eh"};